
export const withParams = (Component, useParams = () => { }, useLocation = () => { }, useNavigate = () => { }) => {
    return props => <Component {...props} params={useParams()} location={useLocation()} navigate={useNavigate()} />
}

/**
 * 节流
 * @param {*} func 
 * @param {*} delay 
 * @returns 
 */
export function _throttle(func, delay = 500) {
    let timeoutId;
    let lastExecTime = 0;

    return function (...args) {
        const currentTime = Date.now();

        if (!lastExecTime || currentTime - lastExecTime >= delay) {
            func(...args);
            lastExecTime = currentTime;
        } else {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
                lastExecTime = currentTime;
            }, delay - (currentTime - lastExecTime));
        }
    };
}

/**
 * 表格分页配置
 */
export const PAGINATION = {
    current: 1,                 // 当前页数
    pageSize: 12,               // 每页条数
    total: 0,                   // 数据总数
    showSizeChanger: true,           // 是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
    showQuickJumper: true,          // 是否可以快速跳转至某页
    showTotal: total => `共 ${total} 条记录` // 用于显示数据总量和当前数据顺序

}

/**
 * 验证电子邮箱格式
 */
export function email(value) {
    return /^\w+((-\w+)|(\.\w+))*[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)
    // return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)
}

/**
 * 验证手机格式
 */
export function mobile(value) {
    return /^1([3589]\d|4[5-9]|6[1-2,4-7]|7[0-8])\d{8}$/.test(value)
}


/**
 * 验证身份证号码
 */
export function idCard(value) {
    return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
        value
    )
}
